import { render, staticRenderFns } from "./identificacion-peligros.vue?vue&type=template&id=eb93ce7c&scoped=true&"
import script from "./identificacion-peligros.vue?vue&type=script&lang=js&"
export * from "./identificacion-peligros.vue?vue&type=script&lang=js&"
import style0 from "./identificacion-peligros.vue?vue&type=style&index=0&id=eb93ce7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb93ce7c",
  null
  
)

export default component.exports